import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { IPatchOperation } from "../../../utils/interfaces";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";
import { auxiliarData } from "../AuxiliarData";

interface IProps {
  id: string;
  active?: boolean;
  hasProperty?: boolean;
}

export async function PatchOrganizationAffiliation({
  id,
  active,
  hasProperty,
}: IProps) {
  const url = `${endpoints.ADMFHIR}/OrganizationAffiliation/${id}`;

  let operations: IPatchOperation[] = [];

  if (hasProperty) {
    operations.push({
      op: "replace",
      path: "/active",
      value: active ? "true" : "false",
    });
  } else {
    operations.push({
      op: "add",
      path: "/active",
      value: active ? "true" : "false",
    });
  }

  const data = auxiliarData.Patch({
    operations,
  });

  const headers = {
    Accept: "application/json-patch+json",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/json-patch+json",
  };

  const response = await useAxios
    .patch(url, data, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`PatchOrganizationAffiliation: ${response.status}`);
      }
      return { data: response.data, status: response.status };
    })
    .catch((error) => {
      console.error("PatchOrganizationAffiliation ", error);
      // toast.error(`PatchSlot Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
